module.exports = __webpack_public_path__ + "img/a_cacahuetes.8fd83f1b.svg";